import { OktaAuth } from '@okta/okta-auth-js';
import { getOktaIssuer, getOktaClientId, getOktaRedirectUri } from '@/common/utilities/env';

// Ported pattern (ignite-ops-portal): when issuer/clientId are absent the app runs with
// NO auth (local, you-only). Set them (OKTA SPA app registration) to turn real login on
// with zero code change.
const issuer = getOktaIssuer();
const clientId = getOktaClientId();
const redirectUri = getOktaRedirectUri() || `${window.location.origin}/login/callback`;

export const isOAuthConfigured = Boolean(issuer && clientId);

export const oktaAuth: OktaAuth | null = isOAuthConfigured
  ? new OktaAuth({
      issuer,
      clientId,
      redirectUri,
      scopes: ['openid', 'email', 'profile', 'offline_access'],
      pkce: true,
    })
  : null;

export default oktaAuth;
